import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { addSearchParamsToUrl, getHHLoginLinkWithBackUrl } from 'utils/clickme';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';

import store from 'store';
import { setLoginData } from 'store/models/user';

const fetchLogin = (dashboardRoute) => {
    fetcher.get(addSearchParamsToUrl('/api/v1/session/login')).then(
        (data) => {
            store.dispatch(setLoginData(data));
            if (data.isNewManager) {
                store.dispatch(push(addSearchParamsToUrl(CREATE_MENU_PAGE_ROUTE)));
            } else {
                store.dispatch(push(dashboardRoute));
            }
        },
        (err) => {
            if (err?.response?.status === 403) {
                store.dispatch(push('/new/forbidden/'));
            }
            if (err?.response?.status === 401) {
                window.location.assign(getHHLoginLinkWithBackUrl());
            }
        }
    );
};

export default fetchLogin;
